export class GravityReservationPopup {
    constructor () {
        this.dialog = document.getElementById('gravity-reservation-popup-dialog');
        this.iframe = document.getElementById('gravity-reservation-popup-iframe');
        this.closeBtn = this.dialog?.querySelector('.gravity-popup-dialog__close');
        this.triggers = document.querySelectorAll('.gravity-popup-trigger');
        this.radioInputs = document.querySelectorAll('.reservation-popup__date input[type="radio"]');

        this.init();
    }

    init () {
        this.bindTriggers();
        this.bindClose();
        this.bindOutsideClick();
        this.bindRadioSync();
        this.bindIframeMessages();

        // Auto open on loading if parameter is found
        this.autoOpen();
    }

    bindTriggers () {
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.open(trigger);
            });
        });
    }

    open (trigger) {
        const url = trigger.dataset.iframeUrl;
        if (url && this.dialog && this.iframe) {
            this.iframe.src = url;
            this.dialog.showModal();
        }
    }

    bindClose () {
        this.closeBtn?.addEventListener('click', () => {
            this.closePopup();
        });
    }

    bindOutsideClick () {
        this.dialog?.addEventListener('click', (e) => {
            if (e.target === this.dialog) {
                this.closePopup();
            }
        });
    }

    bindRadioSync () {
        this.radioInputs.forEach((radio, index) => {
            radio.addEventListener('change', () => {
                this.triggers.forEach(btn => btn.classList.remove('active'));
                if (this.triggers[index]) {
                    this.triggers[index].classList.add('active');
                }
            });
        });
    }

    bindIframeMessages () {
        window.addEventListener('message', (event) => {
            // console.log('[Parent] Received message:', event.data);

            if (event.data?.type === 'gform_confirmation_redirect') {
                console.log(
                    '[Parent] Confirmation redirect detected, URL:',
                    event.data.url
                );

                this.closePopup();

                if (event.data.url) {
                    window.location.href = event.data.url;
                }
            }
        });
    }

    closePopup () {
        if (this.dialog) {
            this.dialog.close();
        }
        if (this.iframe) {
            this.iframe.src = '';
        }
    }

    autoOpen () {
        let params = new URLSearchParams(document.location.search);
        let reservation_hash = params.get('reservation_hash');

        const trigger = Array.from(this.triggers).find(trigger => trigger.dataset.reservationHash === reservation_hash);

        if (trigger) {
            this.open(trigger);
        }
    }
}
